import { useState } from "react";
import { uploadFile } from "../../api/uploadService";

export const useUploadFile = (successCallback) => {
  const [progress, setProgress] = useState(0);

  const upload = async (id, data) => {
    try {
      const newFile = await uploadFile(id, data, setProgress);
      successCallback(newFile);
      setProgress(0); // reset after success
      return newFile;
    } catch (error) {
      console.error("Failed to upload file:", error);
      setProgress(0); // reset on error
      throw error;
    }
  };

  return { upload, progress };
};